module.exports = __webpack_public_path__ + "img/sms-tracking.423092cf.svg";